/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Placeholder(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM187.31348,187.31445a8.00061,8.00061,0,0,1-11.31348,0L68.68652,80A8.00018,8.00018,0,0,1,80,68.68555L187.31348,176A8.00032,8.00032,0,0,1,187.31348,187.31445Z" />
    </Svg>
  );
}

export default Placeholder;
